import type { ServiceGroup } from "@prisma/client";
import parseDate from "~/kernel/dateTime/parseDate";
import transform from "~/kernel/objects/transform";
import type SerializeType from "~/kernel/server/SerializeType";

export default function deserializeServiceGroup(
  serviceGroup: SerializeType<ServiceGroup>,
): ServiceGroup {
  return transform(serviceGroup, {
    createdAt: (date: string) => parseDate(date),
    updatedAt: (date: string) => parseDate(date),
  });
}
